import { NotFoundComponent } from './shared/components/notFound/not-found.component';
import { AuthGuard } from './shared/guards/authGuard/auth.guard';

import { Routes, RouterModule } from '@angular/router';
import { RolModule } from './components/rol/rol.module';
import { MainFrameModule } from './components/mainframe/mainframe.module';
import { NgModule } from '@angular/core';
import { AgendaVirtualModule } from './components/UAC/agenda-virtual/agenda-virtual.module';
import { TableroTurnosModule } from './components/UAC/tablero-turnos/tablero-turnos.module';
import { RegistroIngSalCodigoModule } from './components/registrar-ing-sal-codigo-barras/registro-ing-sal-cod-pbl.module';
import { CargarFotoARLModule } from './components/FUNCIONARIOS/cargar-foto-arl/cargar-foto-arl.module';


export const cargarModuloPrincipal = () => MainFrameModule;
export const cargarModuloRol = () => RolModule;
export const cargarModuloAgendaVirtual = () => AgendaVirtualModule;
export const cargarModuloTableroTurnos = () => TableroTurnosModule;
export const cargarModuloCodigoTalanqueraPublico = () => RegistroIngSalCodigoModule;
export const cargarModuloFotoARL = () => CargarFotoARLModule;

export const routes: Routes = [

  {
    path: '', redirectTo: 'main', pathMatch: 'full'
    , canActivate: [AuthGuard]
  },
  {
    path: 'main', loadChildren: cargarModuloPrincipal
    , canActivate: [AuthGuard]
  },
  {
    path: 'rol', loadChildren: cargarModuloRol
  },
  {
    path: 'agenda-virtual', loadChildren: cargarModuloAgendaVirtual
  },
  {
    path: 'tablero-turnos/:sede', loadChildren: cargarModuloTableroTurnos
  },
  {
    path: 'captura-codigo-publica', loadChildren: cargarModuloCodigoTalanqueraPublico
  },
  {
    path: 'cargar-foto-arl', loadChildren: cargarModuloFotoARL
  },
  {
    path: 'not-found', component: NotFoundComponent
  },
  {
    path: '**', redirectTo: 'not-found'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
